import dt from 'datatables.net-bs4';

const dt_polish = require('./dt.polish.json');
$.fn.DataTable = dt;

$.extend(true, $.fn.dataTable.defaults, {
    resize: true,
    lengthMenu: [ [-1, 10, 25, 50, 100], ["wszystkie" ,10,  25, 50, 100 ] ],
    pageLength: 50,
    responsive: {
        details: {
            display: $.fn.dataTable.Responsive.display.childRowImmediate,
            type: 'none',
            target: ''
        }
    },
    stateSave: true,
    language: {
        ...dt_polish
    },

    dom: "<'row'<'col-12'F>><'row'<'col-12 col-sm-6'l><'col-12 col-sm-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>"
});

let tabs = $("button[data-bs-toggle=\"tab\"]");
tabs.on('shown.bs.tab', function () {
    let tables = $.fn.dataTable.tables(true);
    for (let table of tables) {
        $(table).DataTable().api()
            .columns.adjust()
            .responsive.recalc()
    }
})

// Universal datatables
$(".dt").each(function () {
    let columns = $(this).find('thead tr th').map(function (index, el) {
        return {
            data: $(el).data('name') || index,
        }
    })

    $(this).DataTable({
        columns,
        pageLength: $(this).attr('data-pageLength') || 10,
    });
});

export const dt_simple = table => {
    table = $(table);

    table.DataTable({
        searching: false,
        lengthChange: false
    })
}

$(".dt-simple").each(function() {
    dt_simple($(this));
})

$(".dt-extra-simple").DataTable({
    searching: false,
    lengthChange: false,
    paginate: false,
    info: false
});

export const setData = (table, data) => {
    let tableInstance = $(table).DataTable().api();
    tableInstance.clear();
    tableInstance.rows.add(data).draw();
}

let body = $('body');

// CHECKBOXES
body.on('change', 'table.dataTable input[type="checkbox"].check-all', function() {
    let table = $(this).closest('table');
    let state = $(this).prop('checked');

    let inputs = table.find('tbody input[type="checkbox"]:not(:disabled)');
    const oneByOne = $(this).hasClass('check-all-one-by-one');

    if(oneByOne) {
        for(const input of inputs) {
            if($(input).is(':disabled')) {
                continue;
            }

            if (state) {
                $(input).prop('checked', true).change();
            } else {
                $(input).prop('checked', false).change();
            }
        }
    } else {
        if (state) {
            inputs.prop('checked', true);
        } else {
            inputs.prop('checked', false);
        }

        if (inputs.length > 0) {
            inputs.trigger('change');
        }
    }
})

body.on('draw.dt', 'table.dataTable', function() {
    if($(this).find('.check-all').length > 0) {
        handleCheckAllStateChange($(this).find('.check-all'));
    }
})

setTimeout(() => {
    $('table.dataTable .check-all').each(function() {
        handleCheckAllStateChange($(this));
    })
}, 500);

body.on('change', 'table.dataTable input[type="checkbox"]', function() {
    if($(this).hasClass('check-all')) {
        return;
    }

    let table = $(this).closest('table');
    let checkAllInput = table.find('.check-all');

    if(checkAllInput.length === 0) {
        return;
    }

    handleCheckAllStateChange(checkAllInput);
})

export const handleCheckAllStateChange = (check) => {
    let table = $(check).closest('table');

    let checkboxes = table.find('tbody input[type="checkbox"]');
    let checked = table.find('tbody input[type="checkbox"]:checked');

    let any;

    if (checkboxes.length === checked.length && checked.length !== 0) {
        any = true;
        $(check).prop('checked', true);
        $(check).prop('indeterminate', false);
    } else if (checked.length > 0) {
        any = true;
        $(check).prop('checked', true);
        $(check).prop('indeterminate', true);
    } else {
        any = false;
        $(check).prop('checked', false);
        $(check).prop('indeterminate', false);
    }

    table.trigger('check-all.changed', any);
}

export const getClosestRow = (el) => {
    el = $(el);

    let row = el.closest('tr');
    if(row.hasClass('child')) {
        row = row.prev('tr');
    }

    return row;
}

export const findInTableRow = (row, selector) => {
    row = $(row);

    if(row.hasClass('parent') || row.hasClass('child')) {
        if(row.hasClass('parent')) {
            return $.merge(row.find(selector), row.next('.child').find(selector));
        } else {
            return $.merge(row.find(selector), row.prev('.parent').find(selector));
        }
    }

    return row.find(selector);
}
